import React from "react";
import { SpecialZoomLevel, Viewer, Worker, OpenFile } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import type { ToolbarSlot, TransformToolbarSlot } from "@react-pdf-viewer/toolbar";
import customZoomPlugin from "../plugins/CustomZoomPlugin";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { MOBILE_DEVICES, TIMER_ZERO, WORKER_JS } from "../Constants";
import "../pdfviewer.css"
import { iOSDevice } from "../helpers/Functions";
import { getFilePlugin } from "@react-pdf-viewer/get-file";

export default function PdfViewer(props: any) {
  const toolbarPluginInstance = toolbarPlugin();
  const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;
  const transform: TransformToolbarSlot = (slot: ToolbarSlot) => {
    return Object.assign({}, slot, {
      Open: () => null,
      SwitchTheme: () => null,
      EnterFullScreen: () => null,
      OpenMenuItem: () => null,
      ShowPropertiesMenuItem: () => null,
      ShowProperties: () => null,
      Download: () => { return <DownloadButton /> },
      DownloadMenuItem: () => { return <DownloadMenuItem onClick={() => null } /> },
      EnterFullScreenMenuItem: () => null,
      SwitchThemeMenuItem: () => null
    });
  };
  const customZoomPluginInstance = customZoomPlugin();
  const { zoomTo } = customZoomPluginInstance;
  let zoomLevel: number | SpecialZoomLevel = 0;
  if (matchMedia(MOBILE_DEVICES).matches || iOSDevice()) {
    zoomLevel = SpecialZoomLevel.PageWidth;
  }
  const handleDocumentLoad = () => {
    if (zoomLevel === SpecialZoomLevel.PageWidth) {
      setTimeout(() => {
        zoomTo(zoomLevel);
      }, TIMER_ZERO);
    }
  };
  const getFilePluginInstance = getFilePlugin({
    fileNameGenerator: (file: OpenFile) => {
      return props.fileName;
    },
  });
  const { DownloadButton, DownloadMenuItem } = getFilePluginInstance;
  return (
    <div className="rpv-core__viewer rpv-core-viewer">
      <div className="pdf-toolbar">
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
      </div>
      <div className="worker">
        <Worker workerUrl={WORKER_JS}>
          <Viewer fileUrl={props.url} plugins={[toolbarPluginInstance, customZoomPluginInstance, getFilePluginInstance]} onDocumentLoad={handleDocumentLoad} />
        </Worker>
      </div>
    </div>
  );
};